export default "__VITE_ASSET__sysRUgf9__"